<footer class="footer container">
  <div class="row footer__content">
    <div class="col-12 col-md-5">
      <p>
        Committed to Northern Illinois. NIHIP is a proud member of the Northern Illinois community. We strive to
        collaborate with like-minded organizations to make a difference to our members' lives.
      </p>
    </div>
    <div class="col-md-12">
      <hr />
      <div class="footer__copyright">© {{ year }} North Illinois Health Insurance Program</div>
    </div>
  </div>
</footer>
